import { HttpParams } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnumSiNoTodos } from '../../../core/_infrastructure/types/common';
import { FilterSearchingPanelProductosViewModel, PanelProductosItemResultsViewModel, PanelProductosViewModel } from './panelproductos.types';

@Injectable()
export class PanelProductosService {
    panelProductosEndpoint = this.baseUrl + 'api/mantenimiento/panelproductos/';
    arrBooleanKeys = ['AltaTraces'];
    private lastSearch?: FilterSearchingPanelProductosViewModel;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    private convertModelToHttpParms(payload: FilterSearchingPanelProductosViewModel): HttpParams {
        let params = new HttpParams();
        let k: keyof FilterSearchingPanelProductosViewModel;

        for (k in payload) {
            let v;
            let valor = payload[k];
            if (this.arrBooleanKeys.indexOf(k) !== -1 && valor == EnumSiNoTodos.NO) {
                v = 0;
            } else if (valor instanceof Date) {
                v = (valor as Date).toLocaleDateString();
            } else {
                v = valor || '';
            }
            params = params.append(k, v);
        }

        return params;
    }

    getPanelProductos(payload: FilterSearchingPanelProductosViewModel): Observable<PanelProductosItemResultsViewModel> {
        this.lastSearch = payload; // Keep for future search
        const params = this.convertModelToHttpParms(payload);
        return this.getPagedByFilter(params);
    }

    private getPagedByFilter(params: HttpParams): Observable<PanelProductosItemResultsViewModel> {
        return this.http.get<PanelProductosItemResultsViewModel>(this.panelProductosEndpoint + 'pagedbyfilter/', { params: params });
    }

    getProducto(id: number): Observable<PanelProductosViewModel> {
        return this.http.get<PanelProductosViewModel>(this.panelProductosEndpoint + 'getbyid/' + id);
    }

    saveProducto(producto: PanelProductosViewModel): Observable<any> {
        return this.editProducto(producto);
    }

    editProducto(producto: PanelProductosViewModel): Observable<any> {
        return this.http.put<PanelProductosViewModel>(this.panelProductosEndpoint, producto);
    }

    getLastSearch(): FilterSearchingPanelProductosViewModel | undefined {
        return this.lastSearch;
    }

    clearLastSearch(): void {
        this.lastSearch = undefined;
    }
}
